export default __webpack_public_path__ + "static/media/complementary--when-rainy--g2.5743ee89.png";